import request from '@/config';

enum Apis {
	GetHistoryList = `/api/sysmaterial/getmaterialhistory`,
	GetHistoryData = `/api/sysmaterial/gethistorybyversion`,
	DeleteMaterial = `/api/sysmaterial/deletematerial`,
}

/* 删除附件 */
export const DelMaterialsApi = (delDto: any): Promise<IResponse> => {
	return request.post({ url: Apis.DeleteMaterial, data: delDto });
};

/* Dtos */
import type { MaterialInfoSearch, MaterialSearch, MaterialDelDto, MaterialUploadDto } from './material.dto';

/* 获取编辑器配置数据(编辑) */
export const GetEditorCfgApi = (search: MaterialInfoSearch): Promise<IResponse> => {
	return request.post({ url: '/api/sysmaterial/geteditconfig', data: search });
};

/* 获取编辑器配置数据(预览) */
export const GetPreviewCfgApi = (search: MaterialInfoSearch): Promise<IResponse> => {
	return request.post({ url: '/api/sysmaterial/getpreviewconfig', data: search });
};

/* 获取某个分类资料列表 */
export const GetMaterialsApi = (search: MaterialSearch): Promise<IResponse> => {
	return request.post({ url: '/api/sysmaterial/getmaterialpaged', data: search });
};

/* 上传附件 */
export const UploadApi = (uploadData: MaterialUploadDto | FormData): Promise<IResponse> => {
	return request.post({ url: '/api/sysmaterial/uploadfile', data: uploadData, headersType: 'multipart/form-data' });
};

/* 下载附件 */
export const FileDownloadApi = (materialId: string): Promise<IResponse> => {
	return request.post({ url: '/api/sysmaterial/downloadfile', data: { material_id: materialId }, responseType: 'blob' });
};

/* 下载附件 */
export const CheckMaterialApi = (materialId: string): Promise<IResponse> => {
	return request.post({ url: '/api/sysmaterial/hasmaterial', data: { material_id: materialId } });
};

/* 获取附件编辑历史记录 */
const GetHistoryDataApi = (materialId: string): Promise<IResponse> => {
	return request.post({ url: Apis.GetHistoryList, data: { material_id: materialId } });
};

/* 获取附件编辑历史记录 */
const GetHistoryInfoApi = (materialId: string, ver: number): Promise<IResponse> => {
	return request.post({ url: Apis.GetHistoryData, data: { material_id: materialId, version: ver } });
};

export { GetHistoryDataApi, GetHistoryInfoApi };
